<template>
  <div class="app-container">
    <BjPage ref="BjPage" :query-params="queryParams" :col-span="colSpan" :get-action="queryApi" :serial="serial" :selection="selection" :before-reset-search="beforeResetSearch"
      :default-sort="defaultSort"
      :before-query-search="beforeQuerySearch"
      @handleSelectionChange="handleSelectionChange" @showSetting="SortableTable.show"
      @header-dragend="SortableTable.handleHeaderDragend" @header-contextmenu="SortableTable.handleHeaderContextmenu"
      @sort-change="sortChange"
      >
      <template v-slot:baseForm>
       <el-row :gutter="20" style="padding: 0 10px">
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessPurchaseForecast.skuLabelList')">
            <BjSelectLov v-model="queryParams.skuLabels" :option-list="SKU_TAG_LIST" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessPurchaseForecast.isSuggest')">
            <BjSelectLov v-model="queryParams.isSuggest" :option-list="STATUS_YES_NUM" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessPurchaseOrderDetail.table.skuName')">
            <BjInput v-model="queryParams.skuName" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <BjFormItemCode v-model="queryParams.skuCode" :label="$t('BusinessPurchaseOrderDetail.table.skuCode')" @keyup.enter.native="handleQuery" />
        </el-col>
       </el-row>
       <el-row :gutter="20" style="padding: 0 10px">
        <el-col :span="colSpan">
            <el-form-item :label="$t('goodsPage.categoryName')" prop="categoryIdList">
              <BjGoodsTypeTreeSelect v-model="queryParams.categoryIdList" :limit="1" multiple @change="selectIds" />
            </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessPurchaseForecast.isSale')">
            <BjSelectLov v-model="queryParams.isSale" :option-list="STATUS_YES_NUM" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessPurchaseForecast.priorityLevel')">
            <BjSelectLov v-model="queryParams.priorityLevel" :option-list="PRIORITY_LEVEL_LIST" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessPurchaseOrderList.table.Buyer')">
            <BjInput v-model="queryParams.buyerName" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
       </el-row>
       <el-row :gutter="20" style="padding: 0 10px">
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessPurchaseForecast.isIgnore')">
            <BjSelectLov v-model="queryParams.isIgnore" :option-list="STATUS_YES_NUM" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('SalesOrderToBeApproved.form.Approval')">
            <BjSelectLov v-model="queryParams.status" :option-list="IGNORE_AUDIT_STATUS_LIST" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
            <el-form-item :label="$t('BusinessPurchaseForecast.erpRequestReturnDate')">
              <BjDateTimerangePicker v-model="queryParamsERP_returnDate" :placeholder="$t('BusinessPurchaseForecast.erpRequestReturnDate')"/>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="colSpan">
            <el-form-item :label="$t('BusinessPurchaseSupplier.header.name')">
              <BjInput v-model="queryParams.supplierName" :placeholder="$t('inputText')" clearable @keyup.enter.native="handleQuery" />
            </el-form-item>
        </el-col> -->
       </el-row>
      </template>
      <template v-slot:beforeSearchBtn>
        <el-col :span="24 - colSpan">
          <BjStatusTabs
            :value="auditTabsValue"
            :option-list="TAB_LIST"
            @handleTabClick="handleTabClick"
          />
        </el-col>
      </template>
      <template v-slot:tableOperation>
        <el-col>
          <el-button v-if="auditTabsValue==='ALL'" class="main-btn" :disabled="!selectedRows.length" @click="createPurchaseOrder()">{{ $t('BusinessPurchaseForecast.createPurchaseApply') }}</el-button>
          <el-button v-if="auditTabsValue==='ALL'" type="primary" @click="onExport">{{ $t('exportText') }}</el-button>
          <el-button v-if="auditTabsValue==='ALL'" type="primary" @click="ignore">{{ $t('BusinessPurchaseForecast.ignore') }}</el-button>
<!--          <el-button v-if="auditTabsValue==='ALL'" type="primary" @click="unIgnore">{{ $t('BusinessPurchaseForecast.unIgnore') }}</el-button>-->
          <el-button v-if="auditTabsValue==='IGNORE_REVIEW' && IgnoreAuditPermission" class="main-btn" type="primary" @click="ignoreAuditDialog">{{ $t('table.auditText') }}</el-button>
          <el-button type="primary" @click="() => $refs.tooltipDialog.show()">{{ $t('BusinessPurchaseForecast.userManual') }}</el-button>
        </el-col>
      </template>
      <template v-slot:tableColumn>

        <template v-for="(col, index) in dropCols">
          <vxe-table-column v-if="col.prop === 'skuCode'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" align="center" field="skuCode" :title="$t('BusinessPurchaseOrderDetail.table.skuCode')" width="150px" sortable />
          <vxe-table-column v-else-if="col.prop === 'suggestQty'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" align="center" field="suggestQty" width="140px" sortable>
            <template #header>
                {{ $t('BusinessPurchaseForecast.suggestQty') }}
                <el-tooltip placement="top">
                  <span slot="content">{{ $t('BusinessPurchaseForecast.suggestQtyTooltip') }}</span>
                  <i class="el-icon-question"></i>
                </el-tooltip>
            </template>
          </vxe-table-column>
          <vxe-table-column v-else-if="col.prop === 'totalQty'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" align="center" field="totalQty" width="165px" sortable>
            <template #header>
                {{ $t('BusinessPurchaseForecast.totalQty') }}
                <el-tooltip placement="top">
                  <span slot="content">{{ $t('BusinessPurchaseForecast.totalQtyTooltip') }}</span>
                  <i class="el-icon-question"></i>
                </el-tooltip>
            </template>
          </vxe-table-column>
          <vxe-table-column v-else-if="col.prop === 'totalQtySort'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" align="center" field="totalQtySort" :title="$t('BusinessPurchaseForecast.totalQtySort')" width="140px" sortable />
          <vxe-table-column v-else-if="col.prop === 'inApprovalQty'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" align="center" field="inApprovalQty" width="130px" sortable>
            <template #header>
                {{ $t('BusinessPurchaseForecast.inApprovalQty') }}
                <el-tooltip placement="top">
                  <span slot="content">{{ $t('BusinessPurchaseForecast.inApprovalQtyTooltip') }}</span>
                  <i class="el-icon-question"></i>
                </el-tooltip>
            </template>
          </vxe-table-column>
          <vxe-table-column v-else-if="col.prop === 'approvedQty'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" align="center" field="approvedQty" width="180px" sortable>
            <template #header>
                {{ $t('BusinessPurchaseForecast.approvedQty') }}
                <el-tooltip placement="top">
                  <span slot="content">{{ $t('BusinessPurchaseForecast.approvedQtyTooltip1') }}</span>
                  <i class="el-icon-question"></i>
                </el-tooltip>
            </template>
          </vxe-table-column>
          <vxe-table-column v-else-if="col.prop === 'schedulingQty'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" align="center" field="schedulingQty" width="170px" sortable>
            <template #header>
                {{ $t('BusinessPurchaseForecast.schedulingQty') }}
                <el-tooltip placement="top">
                  <span slot="content">{{ $t('BusinessPurchaseForecast.schedulingQtyTooltip') }}</span>
                  <i class="el-icon-question"></i>
                </el-tooltip>
            </template>
          </vxe-table-column>
          <vxe-table-column v-else-if="col.prop === 'shippingQty'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" align="center" field="shippingQty" width="170px" sortable>
            <template #header>
                {{ $t('BusinessPurchaseForecast.shippingQty') }}
                <el-tooltip placement="top">
                  <span slot="content">{{ $t('BusinessPurchaseForecast.shippingQtyTooltip') }}</span>
                  <i class="el-icon-question"></i>
                </el-tooltip>
            </template>
          </vxe-table-column>
          <vxe-table-column v-else-if="col.prop === 'shipmentQty'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" align="center" field="shipmentQty" width="170px" sortable>
            <template #header>
                {{ $t('BusinessPurchaseForecast.shipmentQty') }}
                <el-tooltip placement="top">
                  <span slot="content">{{ $t('BusinessPurchaseForecast.shipmentQtyTooltip') }}</span>
                  <i class="el-icon-question"></i>
                </el-tooltip>
            </template>
          </vxe-table-column>
          <vxe-table-column v-else-if="col.prop === 'onHandQty'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" align="center" field="onHandQty" width="115px" sortable>
            <template #header>
                {{ $t('BusinessPurchaseForecast.onHandQty') }}
                <el-tooltip placement="top">
                  <span slot="content">{{ $t('BusinessPurchaseForecast.onHandQtyTooltip') }}</span>
                  <i class="el-icon-question"></i>
                </el-tooltip>
            </template>
          </vxe-table-column>
          <vxe-table-column v-else-if="col.prop === 'preOccupyQty'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" align="center" field="preOccupyQty" width="180px" sortable>
            <template #header>
                {{ $t('BusinessPurchaseForecast.preOccupyQty') }}
                <el-tooltip placement="top">
                  <span slot="content">{{ $t('BusinessPurchaseForecast.preOccupyQtyTooltip') }}</span>
                  <i class="el-icon-question"></i>
                </el-tooltip>
            </template>
          </vxe-table-column>
          <vxe-table-column v-else-if="col.prop === 'priorityLevel'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" align="center" field="priorityLevel" width="130px" sortable>
            <template #header>
                {{ $t('BusinessPurchaseForecast.priorityLevel') }}
                <el-tooltip placement="top">
                  <span slot="content">{{ $t('BusinessPurchaseForecast.priorityLevelTooltip1') }}</span>
                  <i class="el-icon-question"></i>
                </el-tooltip>
            </template>
            <template slot-scope="{ row }">
              <el-tag :type="row[col.prop] === '3' ? 'danger' : ''">{{ $t(PRIORITY_LEVEL_LIST.bjGet(row[col.prop])) }}</el-tag>
            </template>
          </vxe-table-column>
          <vxe-table-column v-else-if="col.prop === 'erpRequestReturnDate'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" align="center" field="erpRequestReturnDate" width="160px" sortable>
            <template #header>
                {{ $t('BusinessPurchaseForecast.erpRequestReturnDate') }}
                <el-tooltip placement="top">
                  <span slot="content">{{ $t('BusinessPurchaseForecast.erpRequestReturnDateTooltip1') }}</span>
                  <i class="el-icon-question"></i>
                </el-tooltip>
            </template>
          </vxe-table-column>
          <el-table-column v-else-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center"
            class-name="item">
            <template slot-scope="{ row }">
              <template v-if="false" />
              <template v-else-if="col.prop === 'skuLabelList'">
                <BjTagList :tag-code-array="row[col.prop]" size="mini" />
              </template>
              <template v-else-if="col.prop === 'remark'">
                <el-tooltip class="item" effect="dark" :content="row[col.prop]" placement="top-start">
                  <i class="el-icon-info" style="color: #082dc3"></i>
                </el-tooltip>
              </template>
              <template v-else-if="col.prop === 'remark1'">
                <el-tooltip class="item" effect="dark" :content="row[col.prop]" placement="top-start">
                  <i class="el-icon-info" style="color: #082dc3"></i>
                </el-tooltip>
              </template>
              <template v-else-if="col.prop === 'actualProfitRate'">{{ row[col.prop] | profitMarginFilter }}</template>
              <el-tag v-else-if="col.prop === 'isSuggest'" :type="row[col.prop] ? 'success' : 'info'">{{ $t(STATUS_YES_NUM.bjGet(row[col.prop])) }}</el-tag>
              <el-tag v-else-if="col.prop === 'isSale'" :type="row[col.prop] ? 'success' : 'info'">{{ $t(STATUS_YES_NUM.bjGet(row[col.prop])) }}</el-tag>
              <el-tag v-else-if="col.prop === 'isIgnore'" :type="row[col.prop] ? 'success' : 'info'">{{ $t(STATUS_YES_NUM.bjGet(row[col.prop])) }}</el-tag>
              <span v-else-if="col.prop === 'status'">{{ $t(IGNORE_AUDIT_STATUS_LIST.bjGet(row[col.prop])) }}</span>
              <span v-else>{{ row[col.prop] | timeFilters(row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
            <template slot-scope="{ row }">
              <el-button type="text" class="edit-btn"
                @click="createPurchaseOrder(row)"> {{ $t('BusinessPurchaseForecast.purchaseApply') }} </el-button>
            </template>
          </el-table-column>
        </template>
      </template>
  </BjPage>
  <!-- 忽略弹窗 -->
  <BjDialog :title="$t('BusinessPurchaseForecast.title')" :visible="visible" width="800px" @close="visible = false">
    <el-form ref="formIgnore" :model="formIgnore" :rules="rules">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$t('BusinessPurchaseForecast.deadLine')" prop="endTime">
            <el-date-picker v-model="formIgnore.endTime" type="date" format="dd/MM/yyyy" value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="pickerOptions" :placeholder="$t('chooseText')" clearable class="full-width" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('BusinessPurchaseForecast.ignoreReason')" prop="remark">
            <BjInput v-model="formIgnore.remark" autosize type="textarea" show-word-limit :placeholder="$t('inputText')" @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('cancelText') }}</el-button>
      <el-button type="primary" @click="ignoreConfirm">{{ $t('okText') }}</el-button>
    </span>
  </BjDialog>
  <!--    忽略审核弹窗-->
  <IgnoreAudit ref="IgnoreAudit" @confirm="onConfirm" />
  <!-- 用户手册弹窗 -->
  <tooltipDialog ref="tooltipDialog" />
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { purchaseApi, tagsApi } from '@/api';
import { getLanguage } from '@/lang';
import {IGNORE_AUDIT_STATUS_LIST, STATUS_SKU, STATUS_YES_NUM, USE_FLAG_NUM} from '@/utils/constants';
import IgnoreAudit from './ignoreAudit';
import tooltipDialog from './tooltipDialog';
import { downloadBlob } from '@/utils/index';

export default {
  name: 'BusinessPurchaseForecast',
  components: { IgnoreAudit, tooltipDialog },
  mixins: [pageMiXin],
  data() {
    return {
      USE_FLAG_NUM,
      STATUS_SKU,
      STATUS_YES_NUM,
      IGNORE_AUDIT_STATUS_LIST,
      queryApi: purchaseApi.spurPrediction,
      queryParamsERP_returnDate: null,
      // 查询参数
      queryParams: {
        categoryIdList: null,
        isSuggest: null,
        isSale: null,
        skuCode: null,
        skuLabels: null,
        skuName: null,
        skuStatus: null,
        priorityLevel: null,
        buyerName: null,
        skuSort: null,
        totalQtySort: null,
        inApprovalQtySort: null,
        approvedQtySort: null,
        schedulingQtySort: null,
        shippingQtySort: null,
        shipmentQtySort: null,
        onHandQtySort: null,
        suggestQtySort: null,
        isIgnore: null,
        status: null,
        // supplierName: null,
      },
      labelList: [
        { label: this.$t('BusinessPurchaseOrderDetail.table.skuCode'), prop: 'skuCode', isCheck: true, disabled: false, width: '150' },
        { label: this.$t('BusinessPurchaseOrderDetail.table.skuName'), prop: 'skuName', isCheck: true, disabled: false, width: '150' },
        // { label: this.$t('BusinessPurchaseSupplier.header.name'), prop: 'supplierName', isCheck: true, disabled: false, width: '170' },
        { label: this.$t('BusinessPurchaseForecast.skuLabelList'), prop: 'skuLabelList', isCheck: true, disabled: false, width: '160' },
        { label: this.$t('BusinessPurchaseForecast.totalQty'), prop: 'totalQty', isCheck: true, disabled: false, width: '140' },
        { label: this.$t('BusinessPurchaseForecast.onHandQty'), prop: 'onHandQty', isCheck: true, disabled: false, width: '115' },
        { label: this.$t('BusinessPurchaseForecast.suggestQty'), prop: 'suggestQty', isCheck: true, disabled: false, width: '140' },
        { label: this.$t('BusinessPurchaseForecast.inApprovalQty'), prop: 'inApprovalQty', isCheck: true, disabled: false, width: '130' },
        { label: this.$t('BusinessPurchaseForecast.approvedQty'), prop: 'approvedQty', isCheck: true, disabled: false, width: '160' },
        { label: this.$t('BusinessPurchaseForecast.schedulingQty'), prop: 'schedulingQty', isCheck: true, disabled: false, width: '140' },
        { label: this.$t('BusinessPurchaseForecast.shippingQty'), prop: 'shippingQty', isCheck: true, disabled: false, width: '140' },
        { label: this.$t('BusinessPurchaseForecast.shipmentQty'), prop: 'shipmentQty', isCheck: true, disabled: false, width: '140' },
        { label: this.$t('BusinessPurchaseForecast.preOccupyQty'), prop: 'preOccupyQty', isCheck: true, disabled: false, width: '145' },
        { label: this.$t('BusinessPurchaseForecast.skuAvgDaySales'), prop: 'skuAvgDaySales', isCheck: true, disabled: false, width: '108' },
        { label: this.$t('BusinessPurchaseForecast.lowStockWater'), prop: 'lowStockWater', isCheck: true, disabled: false, width: '123' },
        { label: this.$t('BusinessPurchaseForecast.actualProfitRate'), prop: 'actualProfitRate', isCheck: true, disabled: false, width: '115' },
        { label: this.$t('BusinessPurchaseForecast.priorityLevel'), prop: 'priorityLevel', isCheck: true, disabled: false, width: '130' },
        { label: this.$t('goodsPage.categoryName'), prop: 'categoryName', isCheck: true, disabled: false, width: '135' },
        { label: this.$t('BusinessPurchaseForecast.isSuggest'), prop: 'isSuggest', isCheck: true, disabled: false, width: '143' },
        { label: this.$t('BusinessPurchaseForecast.isSale'), prop: 'isSale', isCheck: true, disabled: false, width: '135' },
        { label: this.$t('BusinessPurchaseForecast.erpRequestReturnDate'), prop: 'erpRequestReturnDate', isCheck: true, disabled: false, width: '160' },
        { label: this.$t('BusinessPurchaseForecast.isIgnore'), prop: 'isIgnore', isCheck: true, disabled: false, width: '135' },
        { label: this.$t('BusinessPurchaseForecast.ignoreReason'), prop: 'remark', isCheck: true, disabled: false, width: '117' },
        { label: this.$t('BusinessPurchaseForecast.endTime'), prop: 'endTime', isCheck: true, disabled: false, width: '135' },
        { label: this.$t('ReturnRefundToBeReviewed.form.Approval'), prop: 'status', isCheck: true, disabled: false, width: '135' },
        { label: this.$t('BusinessPurchaseForecast.remark1'), prop: 'remark1', isCheck: true, disabled: false, width: '117' },
        { label: this.$t('BusinessPurchaseOrderList.table.Buyer'), prop: 'buyerName', isCheck: true, disabled: false, width: '150' },
        { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: '150' },
      ],
      // labelList2: [
      //   { label: this.$t('BusinessPurchaseSupplier.header.name'), prop: 'supplierName', isCheck: true, disabled: false },
      //   { label: 'SKU', prop: 'skuCount', isCheck: true, disabled: false },
      //   { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: '150' },
      // ],
      SKU_TAG_LIST: [],
      PRIORITY_LEVEL_LIST: [
        { value: '3', label: 'A'},
        { value: '2', label: 'B'},
        { value: '1', label: 'C'},
      ],
      visible: false,
      formIgnore: {
        endTime: null,
        remark: null
      },
      rules: {
        endTime: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        remark: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
      },
      ignoreData: [],
      pickerOptions: {
        // 限制时间选择今天及以后的
        disabledDate(time) {
          return time.getTime() < new Date().getTime() - 3600 * 1000 * 24;
        },
      },
      formIgnoreReview: {
        remark1: null,
        auditResult: null
      },
      auditTabsValue: 'ALL',
      TAB_LIST2: [
        {
          label: this.$t('wholeText'),
          value: 'ALL'
        },
        {
          label: this.$t('BusinessPurchaseForecast.ignoreReview'),
          value: 'IGNORE_REVIEW'
        }
        // {
        //   label: this.$t('goodsSku.detail.Supplier'),
        //   value: 'SUPPLIER'
        // },
      ],
      ignoreStatus: '1',
      ignoreAuditList: [],
      defaultSort: [],
      selection: true,
    };
  },
  computed: {
    // labelList() {
    //   if (this.auditTabsValue === 'ALL' || this.auditTabsValue === 'IGNORE_REVIEW') {
    //     return this.labelList1;
    //   } else {
    //     return this.labelList2;
    //   }
    // },
    permissionBtns() {
      return this.$store.state.user.permissionBtns || [];
    },
    TAB_LIST() {
      const list = this.TAB_LIST2.filter((obj) => {
        return this.permissionBtns.includes(obj.value.toLocaleLowerCase());
      }) || [];
      return [
        { label: this.$t('wholeText'), value: 'ALL' },
        ...list
        // { label: this.$t('goodsSku.detail.Supplier'), value: 'SUPPLIER' }
      ];
    },
    IgnoreAuditPermission() {
      return this.TAB_LIST2.some(code => this.permissionBtns.includes(code.value.toLocaleLowerCase()));
    }
  },
  watch: {
    // auditTabsValue: {
    //   handler(v) {
    //     if (v === 'SUPPLIER') {
    //       this.selection = false;
    //       this.queryApi = purchaseApi.getSupplierGroupList;
    //     } else {
    //       this.selection = true;
    //       this.queryApi = purchaseApi.spurPrediction;
    //     }
    //   }
    // },
    queryParamsERP_returnDate(v) {
      this.queryParams.erpRequestReturnDateBegin = (v || [])[0];
      this.queryParams.erpRequestReturnDateEnd = (v || [])[1];
    },
  },
  mounted() {
    this.getSkuTagList();
  },
  methods: {
    ignoreAuditDialog() {
      if (!this.selectedRows.length) {
        this.$message.warning(this.$t('ThreePartySalesOrder.selectDataWarning'));
        return;
      }
      this.ignoreAuditList = [];
      this.selectedRows.forEach(item => {
        this.ignoreAuditList.push(item.skuCode);
      });
      this.$refs.IgnoreAudit.show(this.$t('BusinessPurchaseForecast.ignoreReview'));
    },
    // 忽略审核
    onConfirm(item) {
      const data = {
        auditResult: item.auditResult,
        remark1: item.remark,
        skuList: [
          ...this.ignoreAuditList
        ]
      };
      purchaseApi.purchaseSkuIgnoreAudit(data).then(res => {
        if (!res.failed) {
          this.msgSuccess(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.reFresh();
          }, 500);
        }
      });
    },
    handleTabClick(tab) {
      this.auditTabsValue = tab.name;
      if (tab.name === 'IGNORE_REVIEW') {
        this.queryParams.status = 'WAIT_FIRST_AUDIT';
      } else {
        this.queryParams.status = null;
      }
      // if (tab.name === 'SUPPLIER') {
      //   this.clearQueryParams();
      //   this.queryParams.isSuggest = 1;
      // } else {
      //   this.queryParams.isSuggest = null;
      // }
      this.reFresh();
    },
    sortChange (column) {
      switch (column.property) {
        case 'skuCode':
          this.queryParams.skuSort = column.order;
          break;
        case 'totalQty':
          this.queryParams.totalQtySort = column.order;
          break;
        case 'inApprovalQty':
          this.queryParams.inApprovalQtySort = column.order;
          break;
        case 'approvedQty':
          this.queryParams.approvedQtySort = column.order;
          break;
        case 'schedulingQty':
          this.queryParams.schedulingQtySort = column.order;
          break;
        case 'shippingQty':
          this.queryParams.shippingQtySort = column.order;
          break;
        case 'shipmentQty':
          this.queryParams.shipmentQtySort = column.order;
          break;
        case 'onHandQty':
          this.queryParams.onHandQtySort = column.order;
          break;
        case 'suggestQty':
          this.queryParams.suggestQtySort = column.order;
          break;
      }
      this.defaultSort = column.sortList.map(item => { return { field: item.field, order: item.order}; });
      this.$refs.BjPage.fetchData();
    },
    clearQueryParams() {
      this.queryParamsERP_returnDate = null;
      this.queryParams.categoryNames = null;
      this.queryParams.isSuggest = null;
      this.queryParams.isSale = null;
      this.queryParams.skuCode = null;
      this.queryParams.skuLabels = null;
      this.queryParams.skuName = null;
      this.queryParams.skuStatus = null;
      this.queryParams.categoryIdList = null;
      this.queryParams.priorityLevel = null;
      this.queryParams.buyerName = null;
      this.queryParams.skuSort = null;
      this.queryParams.totalQtySort = null;
      this.queryParams.inApprovalQtySort = null;
      this.queryParams.approvedQtySort = null;
      this.queryParams.schedulingQtySort = null;
      this.queryParams.shippingQtySort = null;
      this.queryParams.shipmentQtySort = null;
      this.queryParams.onHandQtySort = null;
      this.queryParams.suggestQtySort = null;
      this.queryParams.isIgnore = null;
      this.defaultSort = [];
      // this.queryParams.supplierName = null;
    },
    selectIds(value) {
      this.queryParams.categoryIdList = value;
    },
    /** 获取sku标签*/
    getSkuTagList() {
      const data = {
        labelType: 9,
        systemLabelFlag: false,
        status: true,
        pageSize: 40
      };
      tagsApi.getLabels(data).then(res => {
        if (!res.content.length) return;
        this.SKU_TAG_LIST = res.content.map(item => {
          return {
            label: getLanguage() === 'en' ? item.textContent : item.labelName,
            value: item.labelCode
          };
        });
      });
    },
    beforeQuerySearch(conditionObj) {
      // if (this.auditTabsValue === 'SUPPLIER') {
      //     conditionObj.isSuggest = 1;
      // }
      const obj = {
        ...conditionObj,
      };
      return new Promise(resolve => {
        resolve(obj);
      });
    },
    /** 重置按钮操作 */
    beforeResetSearch() {
      this.clearQueryParams();
      return new Promise(resolve => {
        resolve();
      });
    },
    /** 采购申请 */
    purchaseRequest(row) {
    },
     /** 确认忽略 */
    ignoreConfirm() {
      this.$refs.formIgnore.validate(valid => {
        if (valid) {
          const data = {
            endTime: this.formIgnore.endTime,
            remark: this.formIgnore.remark,
            isIgnore: true,
            status: this.IgnoreAuditPermission ? 'COMPLETED' : 'WAIT_FIRST_AUDIT',
            skuList: this.ignoreData
          };
          purchaseApi.purchaseSkuIgnore(data).then(res => {
            if (!res.failed) {
              this.$message.success(this.$t('toast.operationSuccessText'));
              setTimeout(() => {
                this.$refs.BjPage.fetchData();
              }, 800);
            }
          }).finally(() => {
            this.visible = false;
            this.$refs['formIgnore'].resetFields();
          });
        } else {
          return false;
        }
      });
    },
    /** 忽略采购预测 */
    ignore () {
      if (!this.selectedRows.length) {
        this.$message.warning(this.$t('ThreePartySalesOrder.selectDataWarning'));
        return;
      }
      const ignoreStatus = this.selectedRows.every(item => !item.isIgnore);
      if (!ignoreStatus) return this.$message.error(this.$t('BusinessPurchaseForecast.errorMsg'));
      this.ignoreData = [];
      this.visible = true;
      this.selectedRows.forEach(item => {
        this.ignoreData.push(item.skuCode);
      });
    },
    /** 解除忽略 */
    unIgnore () {
      if (!this.selectedRows.length) {
        this.$message.warning(this.$t('ThreePartySalesOrder.selectDataWarning'));
        return;
      }
      const ignoreStatus = this.selectedRows.every(item => item.isIgnore);
      if (!ignoreStatus) return this.$message.error('所选数据必须为忽略状态，请重新选择！');

      const data = this.selectedRows.map(item => item.skuCode);
      this.$confirm(this.$t('InternalSalesOrderDetails.want'))
        .then(_ => {
          purchaseApi.purchaseSkuIgnoreCancel(data).then(res => {
            if (!res.failed) {
              this.$message.success(this.$t('toast.operationSuccessText'));
              setTimeout(() => {
                this.$refs.BjPage.fetchData();
              }, 800);
            }
          });
        })
        .catch(_ => {});
    },
    /** 导出 */
    onExport() {
      purchaseApi.spurPredictionExport(this.queryParams).then(res => {
        downloadBlob(res, this.$t('BusinessPurchaseForecast.exportTitle') + new Date().toLocaleString() + '.xlsx');
      });
    },
    // 创建采购申请单
    async createPurchaseOrder(row) {
      let data = [];
      const skuCode = [];
      // 供应商刘表
      if (this.auditTabsValue === 'SUPPLIER') {
        if (row) {
          const queryParams = {
            supplierName: row.supplierName,
            isSuggest: 1,
            size: row.skuCount,
            page: 0
          };
          const res = await purchaseApi.spurPrediction(queryParams);
          if (!res.content.length) return;
          data = res.content;
        }
      } else {
        // 全部或忽略审核页面
        if (row) {
          data.push(row);
        } else {
          data = this.selectedRows;
        }
      }

      if (!data.length) return;
      data.forEach(item => skuCode.push(item.skuCode));
      // 获取选择项sku的详细信息
      this.toConfirmApi(skuCode, data);
    },
    toConfirmApi(skuCode, data) {
      purchaseApi.purchaseGoodsImport(skuCode).then(res => {
        const differentItems = this.$lodash.differenceBy(data, res, 'skuCode');
        if (differentItems.length > 0) {
          let skuCode = '';
          differentItems.forEach(v => {
            skuCode += v.skuCode + ' ';
          });
          this.msgError(`SKU: ${skuCode}${this.$t('BusinessPurchaseForecast.msgError')}`);
        } else {
          const list = [];
          data.forEach(v1 => {
            res.forEach(v2 => {
              if (v1.skuCode === v2.skuCode) {
                if (!v2.cartonHeight || !v2.cartonLength || !v2.cartonWidth) {
                  list.push(
                    { ...v2,
                      ...v1,
                      cartonHeight: v2.height,
                      cartonLength: v2.length,
                      cartonWidth: v2.width,
                      cartonWeight: v1.cartonWeight || 0,
                      qty: v2.qty || 1,
                      planQty: v1.suggestQty,
                      alreadyQty: v1.suggestQty
                    }
                  );
                } else {
                  list.push(
                    { ...v2,
                      ...v1,
                      qty: v2.qty || 1,
                      cartonWeight: v1.cartonWeight || 0,
                      planQty: v1.suggestQty,
                      alreadyQty: v1.suggestQty
                    }
                  );
                }
              }
            });
          });
          this.$store.commit('business/setPurchasForecast', list);
          setTimeout(() => {
            this.$toPage('BusinessPurchaseApplyIndexAdd', {
              source: 'forecast'
            });
            // this.$refs.BjPage.onResetQuery();
          }, 800);
        }
      });
    },
  },
};
</script>
